import React, { Component } from 'react';
import Uppy from '@uppy/core';
import DragDrop from '@uppy/drag-drop';
import ProgressBar from '@uppy/progress-bar';
import Transloadit from "@uppy/transloadit"
import { toast } from 'react-toastify';
import _ from "lodash";
import '@uppy/core/dist/style.css';
import '@uppy/progress-bar/dist/style.css';
import { BRANDING } from "../../constants/Branding"
import './ImageUploader.scss';

const NOTIFY_URL_BRANDING = `${process.env.REACT_APP_TRANSLOADIT_NOTIFY_URL_UPLOAD}/users/v1/branding-notification`;
class ImageUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: null
    }

    this.uppy = null;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.imageUrl !== state.imageUrl) {
      return { imageUrl: props.imageUrl };
    }

    return null;
  }

  componentDidMount() {
    this.uppy = new Uppy({ debug: false, autoProceed: true });
    this.uppy
      .use(DragDrop, { target: `.UppyDragDrop-${this.props.type}` })
      .use(ProgressBar, { target: `.UppyDragDrop-Progress-${this.props.type}`, hideAfterFinish: true })
      .use(Transloadit, {
        waitForMetadata: true,
        getAssemblyOptions: async (file) => {
          let templateId = "";

          if (this.props.type === BRANDING.LOGO) {
            templateId = process.env.REACT_APP_TEMPLATE_BRANDING_LOGO_PROCESS;
          } else if (this.props.type === BRANDING.FAVICON) {
            templateId = process.env.REACT_APP_TEMPLATE_FAVICON_PROCESS;
          } else if (this.props.type === BRANDING.SITE_IMAGE) {
            templateId = process.env.REACT_APP_TEMPLATE_SITE_IMAGE_PROCESS;
          }
          const tokens = await this.props.Auth.currentSession();

          return {
            params: {
              auth: { key: process.env.REACT_APP_TRANSLOADIT_AUTH_KEY },
              template_id: templateId,
              notify_url: NOTIFY_URL_BRANDING
             },
            // Pass through the fields you need:
            fields: {
              tenantId: this.props.user.tenantId, // TODO grab from session user.tenantId
              accessToken: tokens.accessToken.jwtToken
            },
          }
        }
      });

    this.uppy.on('file-added', file => {
      this.setState({ imageUrl: null });
    });

    this.uppy.on('complete', result => {
      if (result.failed.length === 0) {
        setTimeout(() => {
          this.props.getCurrentCognitoUser();
        }, 10000);
        toast.success("Uploaded successfully", {
          position: toast.POSITION.TOP_RIGHT
        });

        if (this.props.onUploadSuccess) {
          this.props.onUploadSuccess();
        }
      } else {
        toast.error(`Failed to upload ${this.props.type}. Please try again later`, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    });

    if (this.props.imageUrl) {
      this.setState({ imageUrl: this.props.imageUrl });
    }
  }

  onChangeImage = () => {
    const uploadBtn = document.querySelector(`.image-uploader-container-${this.props.type} .uppy-DragDrop-label`);
    uploadBtn.click();
  }

  render() {
    let imageUrl = null;

    if (this.props.imageUrl) {
      if (this.props.type === BRANDING.LOGO) {
        imageUrl = this.props.imageUrl;
      } else if (this.props.type === BRANDING.FAVICON) {
        // migrate away from old pathing
        imageUrl = _.get(this.props.imageUrl, "['favicon-32'][0]['ssl_url']", _.get(this.props.imageUrl, "['favicon-32']", ""));
      } else if (this.props.type === BRANDING.SITE_IMAGE) {
        // migrate away from old pathing
        imageUrl = _.get(this.props.imageUrl, "[':original'][0]['ssl_url']", this.props.imageUrl);
        if (typeof imageUrl !== 'string') {
          imageUrl = "";
        }
      }
    }

    return (
      <div className={`image-uploader-container image-uploader-container-${this.props.type}`}>
        {imageUrl ?
          <img src={imageUrl} className={`UppyDragDrop-${this.props.type}`} alt="preview" onClick={this.onChangeImage} />
          : <div className={`UppyDragDrop-${this.props.type} no-image`} />
        }
        <div className={`UppyDragDrop-Progress-${this.props.type}`} />
      </div>
    );
  }
}

export default ImageUploader;
